import { connect } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next"
import { toast } from "react-toastify";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
    Col,
    Row,
    Label
} from "reactstrap";
import EntityRoutingService from "src/modules/data-protection/apis/EntityRoutingService";

const DeleteRoutingModal = ({
    t,
    toggle,
    show,
    onComplete,
    routingSettings
}) => {
    const entityService = EntityRoutingService.getInstance();

    const restoreSettingsMutation = useMutation({
        mutationFn: async () => {
            return await entityService.restoreRouterSettings(routingSettings?.legal_entity?.id);
        },
        onError: () => {
            toast(t("An error occurred while restoring settings."), {
                type: "error"
            });
        },
        onSuccess: () => {
            toast(t("Settings restored successfully."), {
                type: "success",
            });
            toggle();
            onComplete();
        }
    });

    return (
        <Modal 
            size="lg" 
            isOpen={show}
        >
            <ModalHeader 
                className="border-0" 
                toggle={toggle}
            >
                {t("Delete Routing Settings")}
            </ModalHeader>

            <ModalBody>
                <Row>
                    <Col sm='12' className="mb-3">
                        <Label>    
                            {t("Entity")}
                        </Label>
                        <p className="mb-0">
                            {routingSettings?.legal_entity?.title}
                        </p>
                    </Col>

                    <h5 className="mt-2">
                        <i className="ri-arrow-right-s-fill font-size-22 align-middle" />
                        {t('Software Assets')}
                    </h5>

                    <Col style={{
                        marginLeft: '24px'
                    }}>
                        <Row>
                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Assets To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_software_owner?.id ? (
                                        <>
                                            {routingSettings?.default_software_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Risks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_software_risk_owner?.id ? (
                                        <>
                                            {routingSettings?.default_software_risk_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Tasks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_software_task_owner?.id ? (
                                        <>
                                            {routingSettings?.default_software_task_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Col>

                    <h5 className="mt-2">
                        <i className="ri-arrow-right-s-fill font-size-22 align-middle" />
                        {t('Hardware Assets')}
                    </h5>

                    <Col style={{
                        marginLeft: '24px'
                    }}>
                        <Row>
                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Assets To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_hardware_owner?.id ? (
                                        <>
                                            {routingSettings?.default_hardware_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Risks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_hardware_risk_owner?.id ? (
                                        <>
                                            {routingSettings?.default_hardware_risk_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Tasks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_hardware_task_owner?.id ? (
                                        <>
                                            {routingSettings?.default_hardware_task_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Col>

                    <h5 className="mt-2">
                        <i className="ri-arrow-right-s-fill font-size-22 align-middle" />
                        {t('Other Assets')}
                    </h5>

                    <Col style={{
                        marginLeft: '24px'
                    }}>
                        <Row>
                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Assets To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_other_asset_analyst?.id ? (
                                        <>
                                            {routingSettings?.default_other_asset_analyst?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>
                                    {t("Assign Risks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_other_asset_risk_analyst?.id ? (
                                        <>
                                            {routingSettings?.default_other_asset_risk_analyst?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>
                                    {t("Assign Tasks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_other_asset_task_analyst?.id ? (
                                        <>
                                            {routingSettings?.default_other_asset_task_analyst?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Col>

                    <h5 className="mt-2">
                        <i className="ri-arrow-right-s-fill font-size-22 align-middle" />
                        {t('Incident Reports')}
                    </h5>

                    <Col style={{
                        marginLeft: '24px'
                    }}>
                        <Row>
                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Assets To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_incident_owner?.id ? (
                                        <>
                                            {routingSettings?.default_incident_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Risks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_incident_risk_owner?.id ? (
                                        <>
                                            {routingSettings?.default_incident_risk_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Tasks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_incident_task_owner?.id ? (
                                        <>
                                            {routingSettings?.default_incident_task_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Col>

                    <h5 className="mt-2">
                        <i className="ri-arrow-right-s-fill font-size-22 align-middle" />
                        {t('Data Subject Requests')}
                    </h5>

                    <Col style={{
                        marginLeft: '24px'
                    }}>
                        <Row>
                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Assets To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_dsr_owner?.id ? (
                                        <>
                                            {routingSettings?.default_dsr_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>

                            <Col sm='12' md="4" className="mb-2">
                                <Label>    
                                    {t("Assign Tasks To")}
                                </Label>
                                <p className="mb-0">
                                    {routingSettings?.default_dsr_task_owner?.id ? (
                                        <>
                                            {routingSettings?.default_dsr_task_owner?.full_name}
                                        </>
                                    ) : (
                                        <i className="ri-close-line font-size-24 text-danger" />
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="danger" 
                    onClick={toggle} 
                    disabled={false}
                >
                    {t('Cancel')}
                </Button>

                <Button 
                    color="primary" 
                    onClick={restoreSettingsMutation.mutate}
                    disabled={restoreSettingsMutation.isLoading}
                >
                    {
                        restoreSettingsMutation.isLoading && (
                            <Spinner 
                                animation="border" 
                                variant="primary" 
                                size="sm" 
                                className="me-1"
                            />
                        )
                    }
                    {t('Delete Routing')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

const mapStatetoProps = (state) => {
    const { user: currentUser } = state.Login;
    return {
        currentUser
    };
};

export default withNamespaces()(
    connect(mapStatetoProps)(
        DeleteRoutingModal
    )
);